import { Box } from "@mui/material";
import React from "react";
import NavigationSection from "./NavigationSection";
import CallToActionSection from "./CallToActionSection";
import FeaturesSection from "./FeatureSection";
import ServicesSection from "./ServicesSection";
import HeroSection from "./HeroSection";
import MainContentSection from "./MainContentSection";
import AboutSection from "./AboutSection";
import TestimonialsSection from "./TestimonialsSection";
import FooterSection from "./FooterSection";
import section8Image from "../assets/img/section-8.png";
import HeroHeroSection from "./HeroHeroSection";
const HomePage = () => {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          width: "100%",
          position: "relative",
        }}
      >
        {/* Sections ordered according to the layout in the image */}
        <NavigationSection />
        <HeroHeroSection/>
        {/* <CallToActionSection /> */}
        <FeaturesSection />
        <ServicesSection />
        <HeroSection />
        <MainContentSection />
        <TestimonialsSection />
        <FooterSection />
      </Box>
    </Box>
  );
};

export default HomePage;